import React from 'react';
import { secureWebComponents } from '../helpers/secureWebComponents.js';

// Renders EBDSConsentPrompt that renders DOCK
const ConsentPrompt = ({
  links,
  cookieName,
  enableAlternativeEditView
}) => {
  const atts = {};
  if (links && typeof links === 'object') {
    Object.keys(links).forEach(key => {
      const value = links[key] || null;
      if (!value) {
        return;
      }
      atts[`link-url-${key}`] = value;
    });
  }
  if (cookieName) {
    atts['cookie-name'] = cookieName;
  }
  const consentCategoriesArr = [];
  if (links?.convenience) {
    consentCategoriesArr.push('convenience');
  }
  if (links?.marketing) {
    consentCategoriesArr.push('marketing');
  }
  if (links?.analysis) {
    consentCategoriesArr.push('analysis');
  }
  atts['consent-categories'] = consentCategoriesArr.join(', ');
  if (enableAlternativeEditView) {
    atts['enable-alternative-edit-view'] = true;
  }
  return /*#__PURE__*/React.createElement("ebds-consent-prompt", atts);
};
export default secureWebComponents(ConsentPrompt);